import axios from "axios";
import { API_HOST } from "@/core/variables";

class PermissionRepository {
    find = async (scenarioId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/permission`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };
}

const permissionRepository = new PermissionRepository();

export default permissionRepository; 